"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipelineSync = void 0;
class PipelineSync {
    constructor(terminal) {
        this._middlewares = [];
        this._terminalFunc = terminal || ((input) => input);
    }
    execute(input) {
        const funcsChain = this._middlewares.reduceRight((prev, current) => (input) => current(input, prev), this._terminalFunc);
        const result = funcsChain(input);
        return result;
    }
    use(middleware) {
        this._middlewares.push(middleware);
    }
}
exports.PipelineSync = PipelineSync;
//# sourceMappingURL=PipelineSync.js.map